import {Component, Input, OnChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {CampanhaService} from '../../../services/campanha.service';
import {moeda, telefoneFormatado} from '../crm-segmentos';

const TIPOS = {
  RECUPERADO: {nome: 'Recuperado', cor: '#ea580c', fundo: '#fff0e8'},
  RECORRENTE: {nome: 'Recorrente', cor: '#16a34a', fundo: '#e9f8ef'},
  PRIMEIRO_PEDIDO: {nome: '1º pedido', cor: '#0d9488', fundo: '#e7f7f4'}
};

/** Quanto a campanha trouxe: quem recebeu e pediu na janela, receita e de onde veio. */
@Component({
  selector: 'app-resultado-campanha-crm',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './resultado-campanha-crm.component.html',
  styleUrls: ['./resultado-campanha-crm.component.scss']
})
export class ResultadoCampanhaCrmComponent implements OnChanges {
  @Input() idCampanha: number = null;
  resultado: any = null;
  carregando = false;
  erro = '';
  verTodos = false;
  moeda = moeda;
  telefone = telefoneFormatado;

  constructor(private campanhaService: CampanhaService) {}

  ngOnChanges(): void {
    if (!this.idCampanha) return;
    this.carregando = true;
    this.erro = '';
    this.campanhaService.obtenhaResultado(this.idCampanha).then((resultado: any) => {
      this.resultado = resultado;
      this.carregando = false;
    }).catch((erro: any) => {
      this.erro = typeof erro === 'string' ? erro : 'Não foi possível calcular o resultado.';
      this.carregando = false;
    });
  }

  get origens(): Array<{tipo: string; nome: string; cor: string; clientes: number; receita: number; parte: number}> {
    const r = this.resultado;
    if (!r) return [];
    const total = r.receita || 0;
    return [
      {tipo: 'RECUPERADO', dados: r.recuperados},
      {tipo: 'RECORRENTE', dados: r.recorrentes},
      {tipo: 'PRIMEIRO_PEDIDO', dados: r.primeiroPedido}
    ].map(o => ({tipo: o.tipo, nome: TIPOS[o.tipo].nome, cor: TIPOS[o.tipo].cor,
      clientes: o.dados.clientes, receita: o.dados.receita, parte: total ? Math.round(o.dados.receita / total * 100) : 0}));
  }

  get conversoesVisiveis(): any[] {
    const lista = (this.resultado && this.resultado.conversoes) || [];
    return this.verTodos ? lista : lista.slice(0, 8);
  }

  percentual(valor: number): string {
    return (Number(valor) || 0).toLocaleString('pt-BR', {maximumFractionDigits: 1}) + '%';
  }

  tipo(codigo: string) {
    return TIPOS[codigo] || TIPOS.RECORRENTE;
  }
}
